import React from 'react';
import PropTypes from 'prop-types';
import {
  Alert,
  Button,
  ControlLabel,
  FormGroup,
  HelpBlock
} from 'react-bootstrap';
import { Form, Text } from 'react-form';
import { errorFor } from '../../utils/form';

const ForgotPasswordForm = ({
  loading,
  success,
  error,
  onClose,
  onSubmit,
  validate
}) => (
  <Form onSubmit={onSubmit} validate={validate}>
    {formApi => {
      const usernameError = errorFor(formApi, 'username');

      return (
        <form
          className="tvt-forgot-password__form"
          onSubmit={formApi.submitForm}
        >
          <FormGroup
            validationState={usernameError ? 'error' : null}
            controlId="username"
          >
            <ControlLabel className="tvt-forgot-password__input-label">
              Username
            </ControlLabel>
            <Text
              className="form-control tvt-forgot-password__input"
              id="username"
              field="username"
              type="text"
            />
            <HelpBlock>{usernameError}</HelpBlock>
          </FormGroup>
          {loading && (
            <Button
              className="tvt-forgot-password__submit"
              type="button"
              disabled
            >
              Loading...
            </Button>
          )}
          {!loading && (
            <Button className="tvt-forgot-password__submit" type="submit">
              Reset Password
            </Button>
          )}
          {success && (
            <Alert bsStyle="success" style={{ marginTop: '20px' }}>
              <h4>Success!</h4>
              <p>Please check your email to reset your password.</p>
            </Alert>
          )}
          {error && (
            <Alert bsStyle="danger" style={{ marginTop: '20px' }}>
              <h4>Ooops!</h4>
              <p>{error}</p>
            </Alert>
          )}
          <span className="tvt-forgot-password__back" onClick={onClose}>
            Back to page
          </span>
        </form>
      );
    }}
  </Form>
);

ForgotPasswordForm.propTypes = {
  loading: PropTypes.bool,
  success: PropTypes.bool,
  error: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  onClose: PropTypes.func,
  onSubmit: PropTypes.func.isRequired,
  validate: PropTypes.func
};

ForgotPasswordForm.defaultProps = {
  loading: false,
  success: false,
  error: false,
  onClose: () => {},
  validate: () => {}
};

export default ForgotPasswordForm;
